import {
  UPLOAD_ATTACHMENT_SUCCESS,
  DELETE_ATTACHMENT_SUCCESS,
  UPDATE_OUTLINE_SUCCESS,
  CHECK_ATTACHMENT_STATUS_SUCCESS_AI_CREATOR,
} from './type'

// eslint-disable-next-line import/no-anonymous-default-export
export default function (
  state = {
    attachments: [],
    errorOccurred: {
      error: false,
      message: '',
    },
    outline: null,
  },
  action,
) {
  const { payload, type } = action
  switch (type) {
    case UPDATE_OUTLINE_SUCCESS:
      return state
    case UPLOAD_ATTACHMENT_SUCCESS:
      const fileName = payload?.fileName
      const fileId = payload?.response?.attachment_id
      if (fileName == undefined && fileId == undefined) {
        return {
          ...state,
          attachments: [],
        }
      }
      return {
        ...state,
        attachments: [
          ...state.attachments,
          {
            file_name: fileName,
            attachment_id: fileId,
            succeeded: false,
            file_url: null,
          },
        ],
      }
    case CHECK_ATTACHMENT_STATUS_SUCCESS_AI_CREATOR:
      return {
        ...state,
        attachments: state.attachments.map(attachment => {
          if (attachment.attachment_id === payload.response.attachment_id) {
            return {
              ...attachment,
              succeeded: payload.response.succeeded,
              file_url: payload.response.fileUrl,
            }
          }
          return attachment
        }),
      }

    case DELETE_ATTACHMENT_SUCCESS:
      return {
        ...state,
        attachments: state.attachments.filter(
          attachment => attachment.attachment_id !== payload.response,
        ),
      }
    default:
      return state
  }
}
